import {
  Box,
  Flex,
  Heading,
  Highlight,
  Link,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Text,
  UnorderedList,
  ListItem
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { BACKEND_URL } from '../../../../api/requests';

import CsvDataDisplay from './CsvDataDisplay';
import FileDropZone from './FileDropZone';
import ImageDisplay from './ImageDisplay';

function FileUpload(props) {
  const { isOpen, handleClose, fileUploadInfo, type } = props;
  const [csvData, setCsvData] = useState(null);
  const [image, setImage] = useState(null);

  const onClose = shouldRefresh => {
    setCsvData(null);
    setImage(null);
    handleClose(shouldRefresh);
  };

  let setter = null;
  let uploadDisplay = null;
  const csvInstructions = (
    <Flex marginTop='20px' justify='center' align='center' flexDir='column'>
      <Heading marginBottom='10px'>Instructions</Heading>
      <UnorderedList>
        <ListItem>
          <Text fontSize='l'>
            <Highlight
              query={['Batch Number', 'Manufacturing Date', 'Expiry Date', 'Quantity']} styles={{ px: '2', py: '1', rounded: 'full', bg: 'red.100' }}
              >
              Required columns: Batch Number, Manufacturing Date, Expiry Date, and Quantity
            </Highlight>
          </Text>
        </ListItem>
        <ListItem>
          <Text fontSize='l'>
            <Highlight
                query={['DD/MM/YY']} styles={{ px: '2', py: '1', rounded: 'full', bg: 'red.100' }}
                >
                Date format must be DD/MM/YY (e.g., 15/01/24)
              </Highlight>
          </Text>
        </ListItem>
        <ListItem>
          <Text fontSize='l'>
            <Highlight
                query={['City', 'Country']} styles={{ px: '2', py: '1', rounded: 'full', bg: 'red.100' }}
                >
                City and Country indicate product destination
              </Highlight>
          </Text>
        </ListItem>
        <ListItem>
          <Text fontSize='l'>
            <Highlight
                query={['Public', 'Private']} styles={{ px: '2', py: '1', rounded: 'full', bg: 'blue.100' }}
                >
                Public fields are visible to everyone; Private fields are only visible to you (the issuer)
              </Highlight>
          </Text>
        </ListItem>
        <ListItem>
          <Text fontSize='l'>
            <Highlight
                query={['Number of [child] per [parent]']} styles={{ px: '2', py: '1', rounded: 'full', bg: 'green.100' }}
                >
                Define hierarchy using headers like Number of [child] per [parent]. A parent exact quantity column must precede its child.
              </Highlight>
            <br />
            Allowed variants: pallet, box, carton, package, capsule, bottle, pack.
          </Text>
        </ListItem>
        <ListItem>
          <Text fontSize='l'>
            <Link color='teal.500' href={`${BACKEND_URL}/productions/sample-csv`}>Download sample CSV file</Link>
          </Text>
        </ListItem>
      </UnorderedList>
    </Flex>
  );
  if (type === 'csv') {
    setter = setCsvData;
    uploadDisplay = csvData &&
      <CsvDataDisplay
        csvData={csvData}
        closeUpload={onClose}
        eventId={fileUploadInfo._id}
        eventName={fileUploadInfo.eventName}
      />;
  } else {
    setter = setImage;
    uploadDisplay = image &&
      <ImageDisplay
        imageFile={image}
        closeUpload={onClose}
        eventId={fileUploadInfo._id}
        eventName={fileUploadInfo.eventName}
      />;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxW='90%' h='90%'>
        <ModalCloseButton/>
        <ModalBody w='100%' h='100%' flexDirection='column' display='flex' alignItems='center' justifyContent='center'>
          {type === 'csv' && csvInstructions}
          <Box w='100%' h='100%' overflow='auto' className='custom-scrollbar'>
            {!csvData && !image && <FileDropZone setter={setter} type={type}/>}
            {uploadDisplay}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

FileUpload.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  fileUploadInfo: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['csv', 'img']).isRequired
};

export default FileUpload;
